import React from 'react';
import PropTypes from 'prop-types';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem, InlineGrid } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import LogoRow from '@marvelapp/marvel-ui/logo-row';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Position from '@marvelapp/marvel-ui/position';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Page from 'marketing-website/components/modules/Page';
import LandingPagesWrap from 'marketing-website/components/modules/LandingPagesWrap';
import fourLogos from 'marketing-website/configs/pages/enterprise/logos-4.js';
import EnterpriseForm from 'marketing-website/components/modules/EnterpriseForm';
import TickedCopy from 'marketing-website/components/modules/TickedCopy';
import {
  getEnterpriseFormContent,
  requestMarvel3FormId,
} from 'marketing-website/configs/hubspot';
import { getQueryParameterByName } from 'marketing-website/utils/params';
import metaData from 'marketing-website/data/metadata.js';

const meta = {
  title: metaData['request-demo'].title,
  meta: [
    {
      name: 'description',
      content: metaData['request-demo'].description,
    },
    {
      name: 'keywords',
      content: metaData['request-demo'].keywords,
    },
  ],
  header: false,
  footer: false,
};

export default function EnterpriseRequestQuote(history) {
  const formId = getQueryParameterByName('hformid') || requestMarvel3FormId;
  const content = getEnterpriseFormContent(formId);
  return (
    <Page {...meta}>
      <Position type="absolute" location="all">
        <Align type="middle">
          <div id="enterprise-form">
            <LandingPagesWrap history={history} showBackButton>
              <Spacing size="m" position="topBottom" type="padding">
                <PageWrap size="m" maxWidth={1080}>
                  <Grid columns={12} size="m">
                    <GridItem columnSpan={12} columnSpanM={7}>
                      <div
                        style={{ height: 120 }}
                        className="breakPointM-display-none"
                      />
                      <MaxWidth value={500}>
                        <Heading size="xxl" weight="bold">
                          {content.title}
                        </Heading>
                      </MaxWidth>
                      <Spacing type="margin" size="m" position="top">
                        <MaxWidth value={500}>
                          <Spacing
                            size="s"
                            position="topBottom"
                            type="margin"
                          />
                          <Grid columns={1} size="m">
                            <GridItem>
                              {content.features.map(item => (
                                <Spacing
                                  key={item.feature}
                                  size="xs"
                                  position="topBottom"
                                  type="margin"
                                >
                                  <InlineGrid size="s">
                                    <TickedCopy>{item.feature}</TickedCopy>
                                  </InlineGrid>
                                </Spacing>
                              ))}
                            </GridItem>
                          </Grid>
                        </MaxWidth>
                      </Spacing>
                      <Spacing type="margin" size="l" position="top">
                        <LogoRow align="left" spacing="l" logos={fourLogos} />
                      </Spacing>
                    </GridItem>
                    <GridItem columnSpan={12} columnSpanM={5}>
                      <Spacing size="m" position="top" type="margin">
                        <EnterpriseForm
                          ctaCopy={'Request a Demo'}
                          hubspotId={formId}
                        />
                      </Spacing>
                    </GridItem>
                  </Grid>
                  <div
                    style={{ height: 120 }}
                    className="breakPointM-display-none"
                  />
                </PageWrap>
              </Spacing>
            </LandingPagesWrap>
          </div>
        </Align>
      </Position>
    </Page>
  );
}

EnterpriseRequestQuote.propTypes = {
  history: PropTypes.object.isRequired,
};

EnterpriseRequestQuote.defaultProps = {};



// WEBPACK FOOTER //
// ./src/pages/enterprise/request-demo/index.js